/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Oops_Data_UnavailableInputs */

const en_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oops, Data unavailable!`)
};

const ar_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عذرًا، البيانات غير متوفرة!`)
};

const bn_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দুঃখিত, ডেটা লোড হচ্ছে না!`)
};

const de_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppla, Daten nicht verfügbar!`)
};

const es_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay datos disponibles`)
};

const fr_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données indisponibles`)
};

const pt_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados indisponíveis`)
};

const zh_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`糟糕，数据不可用！`)
};

const tr_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata! Veriler kullanılamıyor!`)
};

const ru_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`К сожалению, данные недоступны!`)
};

const pl_error_oops_data_unavailable = /** @type {(inputs: Error_Oops_Data_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups, dane niedostępne!`)
};

/**
* | output |
* | --- |
* | "Oops, Data unavailable!" |
*
* @param {Error_Oops_Data_UnavailableInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_oops_data_unavailable = /** @type {((inputs?: Error_Oops_Data_UnavailableInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Oops_Data_UnavailableInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_error_oops_data_unavailable(inputs)
	if (locale === "bn") return bn_error_oops_data_unavailable(inputs)
	if (locale === "de") return de_error_oops_data_unavailable(inputs)
	if (locale === "es") return es_error_oops_data_unavailable(inputs)
	if (locale === "fr") return fr_error_oops_data_unavailable(inputs)
	if (locale === "pt") return pt_error_oops_data_unavailable(inputs)
	if (locale === "zh") return zh_error_oops_data_unavailable(inputs)
	if (locale === "tr") return tr_error_oops_data_unavailable(inputs)
	if (locale === "ru") return ru_error_oops_data_unavailable(inputs)
	if (locale === "pl") return pl_error_oops_data_unavailable(inputs)
	return en_error_oops_data_unavailable(inputs)
});